module.exports = {
  auditTrail: (Api, $stateParams) ->
    query =
      offset: $stateParams.start or 0
      user: $stateParams.user or null
      event: $stateParams.event or null

    if $stateParams.projectId
      query['project'] = $stateParams.projectId
    return Api.AuditTrail.get(query).$promise

  managedUsers: (Api) ->
    return Api.SimpleManagedUser.query({is_active: true}).$promise

  project: (Api, $stateParams) ->
    return Api.Project.get(id: $stateParams.projectId).$promise
}
